import { _js } from '@ifixit/utils/localize';
import { TiptapButton } from '../TiptapButton';
import { FaIcon } from '@ifixit/ui/components/icon';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const UnindentButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isDisabled: !editor.can().liftListItem('listItem'),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().liftListItem('listItem').run()}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="outdent" />}
         title={_js('Decrease indent')}
         overrideShortcut={'shift+tab'}
      />
   );
};
